/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

/**
 * A version of Function.bind() that preserves types.
 */

// Bind just the context for a function of up to 4 args.
export function tbind<T, R, Args extends any[]>(func: (this: T, ...a: Args) => R, context: T): (...a: Args) => R;

// Bind context and first arg for a function of up to 5 args.
export function tbind<T, R, X, Args extends any[]>(
  func: (this: T, x: X, ...a: Args) => R, context: T, x: X,
): (...a: Args) => R;

export function tbind(func: any, context: any, ...boundArgs: any[]): any {
  return func.bind(context, ...boundArgs);
}
